import { useCallback } from 'react';

import { isPortfolioApp as checkIsPortfolioApp } from '@/utils/environment/surface';

import ensureSufficientCredits from './ensureSufficientCredits';
import openOfferIfInsufficient from './openOfferIfInsufficient';

interface RequireCreditsParams {
  flowId: string;
  presetCreditCount?: number | null;
}

/**
 * The single React entry point for credits.
 *
 *   - `requireCredits(flowId)`: the gate-time check. Returns true if the user
 *     can proceed; on insufficient credits opens the offer/upsell modal with
 *     the correct toolId for the current surface.
 */
const useCredits = () => {
  const isPortfolioApp = checkIsPortfolioApp();

  const requireCredits = useCallback(
    async ({
      flowId,
      presetCreditCount,
    }: RequireCreditsParams): Promise<boolean> => {
      const result = await ensureSufficientCredits({
        flowId,
        presetCreditCount,
      });
      if (result.sufficient) return true;
      openOfferIfInsufficient(result, {
        preferSubscription: isPortfolioApp,
      });
      return false;
    },
    [isPortfolioApp]
  );

  return { requireCredits };
};

export default useCredits;
